import React from 'react';
import { CaptionLabelProps } from 'react-day-picker-for-new-calendar';
import { Stack } from '@mui/material';

import { Navbar } from '../Navbar';
import { CaptionSelector } from '../CaptionSelector';


type CaptionLabel = CaptionLabelProps & {
    onClick: () => void;
};


export const CaptionLabel: React.FC<CaptionLabel> = ({
    displayMonth,
    onClick,
}) => (
    <Stack position='relative'>
        <Navbar />

        <CaptionSelector
            displayMonth={displayMonth}
            onClick={onClick}
        />
    </Stack>
);
